<script setup lang="ts">
  import type { ICloseArgs } from '#shared/types/modal.types';
  import type { TDepositMethod } from '~/store/cashier';
  import { CashierDepositWithCard, CashierDepositWithCrypto } from '#components';
  import { EDepositMethod } from '~/store/cashier';

  const emit = defineEmits<{ close: [ICloseArgs] }>();

  const gtag = useGtag();

  const depositMethod = ref<TDepositMethod>(EDepositMethod.Card);
  const activeComponent = computed(() => {
    if (depositMethod.value === EDepositMethod.Card) return CashierDepositWithCard;
    return CashierDepositWithCrypto;
  });

  function setDepositMethod(method: TDepositMethod) {
    depositMethod.value = method;
    gtag.reportGtagConversion();
  }

  function closeModal() {
    emit('close', {});
  }
</script>

<template>
  <component :is="activeComponent" @change-method="setDepositMethod" @close="closeModal" />
</template>
